<template>
	<app-table :columns="columns" :data="discounts" :debounceInterval="300">
		<template v-slot:title="{ item }">
			<app-details-shortcut
				class="text-info hover:underline"
				:route-name="RouteNames.DiscountDetails"
				:identifier="encrypt(item.id)"
			>
				{{ item.title }}
			</app-details-shortcut>
		</template>
		<template v-slot:percentage="{ item }">
			<app-checkbox :model-value="item.percentage" disabled />
		</template>
		<template v-slot:customersNo="{ item }">
			{{ item.customersNo === 0 ? 'All Customers' : item.customersNo }}
		</template>
		<template v-slot:startDate="{ item }">
			{{ $filters.formatDate(item.startDate) }}
		</template>
		<template v-slot:endDate="{ item }">
			{{ $filters.formatDate(item.endDate) }}
		</template>
		<template v-slot:status="{ item }">
			<app-switch
				offLabel="Inactive"
				onLabel="Active"
				:model-value="item.status"
				:disabled="!canEdit"
				@change="$emit('statusChange', item, $event)"
			/>
		</template>
		<template v-if="canEdit" v-slot:actions="{ item }">
			<app-button class="btn btn-info transparent small" icon="pencil" @click="$emit('edit', item)" />
		</template>
	</app-table>
</template>

<script>
	import orders from '@/constants/orders';
	import RouteNames from '@/router/names';
	import AppTable from '@/components/app/AppTable';
	import AppCheckbox from '@/components/app/AppCheckbox';
	import AppSwitch from '@/components/app/AppSwitch';
	import AppDetailsShortcut from '@/components/app/AppDetailsShortcut';
	import UtilityService from '@/services/UtilityService';

	export default {
		name: 'DiscountsTable',
		components: { AppSwitch, AppCheckbox, AppTable, AppDetailsShortcut },
		props: ['discounts', 'canEdit'],
		data: () => ({
			RouteNames,
			columns: orders.discountColumns,
		}),
		methods: {
			encrypt(id) {
				return UtilityService.encrypt(id);
			},
		},
	};
</script>

<style scoped></style>
